module.exports = __webpack_public_path__ + "static/media/other.42cb86be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/other.svg
// module id = 166
// module chunks = 0